import { render, staticRenderFns } from "./CopyTrip.vue?vue&type=template&id=28afc696&scoped=true&"
import script from "./CopyTrip.vue?vue&type=script&lang=js&"
export * from "./CopyTrip.vue?vue&type=script&lang=js&"
import style0 from "./CopyTrip.vue?vue&type=style&index=0&id=28afc696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afc696",
  null
  
)

export default component.exports